import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";

import { withRouter } from "react-router-dom";
import cardIcon from '../../assets/images/icon-card.png'
import { getDataList } from '../../actions/flow'

const styles = () => {
  return {
    cardContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '32px 17px',
    },
    card: {
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'space-between',
      width: 'calc(25% - 18px)',
      height: '164px',
      marginLeft: '24px',
      marginBottom: '24px',
      padding: '30px 24px',
      background: '#fff',
      '&:nth-child(4n + 1)': {
        marginLeft: '0'
      }
    },
    title: {
      fontSize: '22px',
      lineHeight: '26px',
      color: '#4a4a4a',
      fontWeight: 'bold'
    },
    dateLine: {
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    date: {
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.45)',
      lineHeight: '22px'
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      background: '#1890FF',
      '& img': {
        width: '17px',
        height: '17px'
      },
      '&.bg-1': {
        background: '#1890FF'
      },
      '&.bg-2': {
        background: '#39C07A'
      },
      '&.bg-3': {
        background: '#FF6100'
      },
      '&.bg-4': {
        background: '#A4D322'
      },
      '&.bg-5': {
        background: '#FF9E00'
      },
      '&.bg-6': {
        background: '#5EC6D0'
      },
      '&.bg-7': {
        background: '#F04C35'
      },
    }
  }
};

class DataClass extends Component {
  state = {
    keyword: "",
    userId: "", //用户id
    username: "", //用户名
    cardList: []
  };

  componentDidMount() {
    this.init()
  }

  //初始化
  init = () => {
    getDataList({
      owner_name: '直观复兴'
    }).then(res => {
      this.setState({
        cardList: res.results
      })
    })
  };

  jumpLink = (data) => {
    if (data.is_internal) {
      this.props.history.push(data.model_url)
    } else {
      let a = document.createElement('a')
      a.href = data.model_url
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
  render() {
    const classes = this.props.classes;

    return (
      <Grid className={classes.cardContainer}>
        {
          this.state.cardList.map((item, i) => (
            <Grid key={i} className={classes.card} onClick={() => this.jumpLink(item)}>
              <Typography className={classes.title}>{item.model_name}</Typography>
              <Grid className={classes.dateLine}>
                <span className={classes.date}>{item.date}</span>
                <span className={[classes.icon, `bg-${i + 1}`].join(' ')}>
                  <img src={cardIcon} />
                </span>
              </Grid>
            </Grid>
          ))
        }
      </Grid>
    );
  }
}

export default withStyles(styles)(withRouter(DataClass));
